import React, { Fragment } from 'react'

import { ListItemText, ListItem, ListSubheader } from '@material-ui/core'

import InputGroup from '../../../../../../UI/Forms/InputGroup/InputGroup'

const STT05ItemList = ({ itemList = {}, selectedTags, tagSelected, translate }) => {
  const competencyTypeGroups = Object.entries(itemList).reduce((groups, comGroup) => {
    const [groupCode, groupAttrs] = comGroup
    const groupItems = groupAttrs.items

    if (!groupAttrs) {
      return groups
    }

    const tags = groupItems.flatMap(item => item.tags)

    const mergedTags = Array.from(new Set(tags))
    return {
      ...groups,
      [groupCode]: {
        ...groupAttrs,
        items: groupItems,
        tags: mergedTags
      }
    }
  }, {})

  const competencyGroupDisplay = Object.entries(competencyTypeGroups).map(group => {
    const [groupKey, groupAttrs] = group
    return (
      <Fragment key={groupKey}>
        <ListSubheader>{groupAttrs.competency_type_name}</ListSubheader>
        <ListItem>
          <ListItemText>
            <InputGroup
              label={translate('tag')}
              inputType={'newmultiSelect'}
              inputValue={selectedTags[groupKey] ?? []}
              changed={tags => tagSelected(tags, groupKey)}
              configs={{
                options: groupAttrs.tags
              }}
            />
          </ListItemText>
        </ListItem>
      </Fragment>
    )
  })
  return <Fragment>{competencyGroupDisplay}</Fragment>
}

export default STT05ItemList
